import React, { useState, useEffect } from "react";

function DrinksAlc() {

    const [drinksAlc, setDrinksAlc] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items')
        .then(response => response.json())
        .then(data => {
            const category = data.data.find(item => item.name === 'DRINKI');

            if (category) {
                setDrinksAlc(category.menu_items);
            };
        });
    }, []);

    return(

        <div className="container-fluid pb-5 mb-5">
            <div className="container">
        <p className="menu-item-title-font fs-1 fw-bold pt-5">DRINKI</p>
        <hr/>
        {drinksAlc.map((drinkAlc) => (
            <div key={drinkAlc.id} className="container">
                <div className="dish-name-container d-flex justify-content-between">
                    <p className="menu-item-title-font fs-5 m-0">{drinkAlc.name}</p>
                    <p className="fs-5 m-0">{drinkAlc.price}zł</p>
                </div>
                <p className="ingridients-container fs-6 m-0 fw-lighter">{drinkAlc.ingredients}</p>
                <div className="mb-3 mt-3 divide-line"/>
            </div>
        ))}
        </div>
        </div>

    )
}

export default DrinksAlc;